// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"519":"7e60dabb","994":"0a1fc9c5"}[chunkId] + ".chunk.css";
};